'use client'

import Text from '@/components/custom-ui/text'
import { Button } from '@/components/ui/button'
import Link from 'next/link'

interface ErrorPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

const ErrorPage = ({ error, reset }: ErrorPageProps) => {
  return (
    <main className="flex h-full w-full">
      <div className="flex h-[50vh] w-full flex-col items-center justify-center">
        <Text as="h1" className="font-bold" markdown>
          Something went *wrong*
        </Text>
        <Text className="mt-6 text-base leading-7 text-gray-600">
          Sorry, there was an error while processing your request.
        </Text>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button onClick={reset}>Try again</Button>
          <Button asChild variant="outline">
            <Link href="/">Go back home</Link>
          </Button>
        </div>
      </div>
    </main>
  )
}
export default ErrorPage
